 import videojs from 'video.js';
 import flvjs from "./../../thirdparty/flv/flv.min.265";
 import { cloneDeep } from "lodash";

 window.flvjs = flvjs;

 flvjs.LoggingControl.enableDebug = false
 flvjs.LoggingControl.enableVerbose = false
 flvjs.LoggingControl.enableInfo = false
 flvjs.LoggingControl.enableWarn = true
 flvjs.LoggingControl.enableError = true

 const Html5 = videojs.getTech('Html5');
 const mergeOptions = videojs.mergeOptions || videojs.util.mergeOptions;
 const defaults = {
   mediaDataSource: {},
   config: {}
 };
 const MAX_NO_DECODER_FRAME = 10;
 class Flvjs extends Html5 {

   // 初始化
   constructor(options, ready) {
     options = mergeOptions(defaults, options);
     super(options, ready);
     this.warpSrc = null
     this.retryCount = options.config.retryCount ? options.config.retryCount : 0
     this.frameDetect = options.config.frameDetect ? options.config.frameDetect : false
     this.frameDecodeMaxNum = MAX_NO_DECODER_FRAME
     this.lastDecoderFrame = 0
     this.videoEndedFn = this.handleFlvEnd.bind(this);
   }

   //流切换
   setSrc(src) {
     if (this.flvPlayer) {
       this.flvPlayer.detachMediaElement();
       this.flvPlayer.destroy();
     }
     this.warpSrc = src;
     const mediaDataSource = cloneDeep(this.options_.mediaDataSource);
     const config = cloneDeep(this.options_.config);
     mediaDataSource.type = mediaDataSource.type === undefined ? 'flv' : mediaDataSource.type;
     mediaDataSource.url = src;
     this.flvPlayer = window.flvjs.createPlayer(mediaDataSource, config);
     this.flvPlayer.attachMediaElement(this.el_);
     if (this.frameDetect) {
      this.flvPlayer.on('statistics_info', this.handleDecoderFrame.bind(this))       
     }
     this.flvPlayer.load();
     if (this.retryCount) {
      this.el_.addEventListener('ended', this.videoEndedFn);
     }
   }
   // 帧检测
   handleDecoderFrame(res) {
     console.log("handleDecoderFrame", res.decodedFrames, "lastDecoderFrame" , this.lastDecoderFrame, "frameDecodeMaxNum", this.frameDecodeMaxNum)
     if (this.lastDecoderFrame === res.decodedFrames) {
      this.frameDecodeMaxNum = this.frameDecodeMaxNum >= 1 && this.frameDecodeMaxNum - 1
      if (this.frameDecodeMaxNum === 0) {
        this.frameDecodeMaxNum = MAX_NO_DECODER_FRAME
        this.setSrc(res.url);
      }
     } else {
      this.frameDecodeMaxNum = MAX_NO_DECODER_FRAME
     }

     this.lastDecoderFrame = res.decodedFrames
   }
   // 无限重播机制
   handleFlvEnd() {
    this.el_.removeEventListener('ended', this.videoEndedFn)
    if (this.warpSrc && this.retryCount > 0) {
      this.retryCount--;
      this.setSrc(this.warpSrc);
    }
   }
   /**
    * 销毁
    */
   dispose() {
     if (this.flvPlayer) {
       this.flvPlayer.detachMediaElement();
       this.flvPlayer.destroy();
     }
     super.dispose();
   }

 }

 // 是否支持flv
 Flvjs.isSupported = function () {

   return window.flvjs && window.flvjs.isSupported();
 };

 // 支持类型
 Flvjs.formats = {
   'video/flv': 'FLV',
   'video/x-flv': 'FLV'
 };

 // 支持类型
 Flvjs.canPlayType = function (type) {
   if (Flvjs.isSupported() && type in Flvjs.formats) {
     return 'maybe';
   }

   return '';
 };

 // VideoJS 拦截
 Flvjs.canPlaySource = function (srcObj, options) {
   return Flvjs.canPlayType(srcObj.type);
 };

 Flvjs.VERSION = '__VERSION__';

 videojs.registerTech('Flvjs', Flvjs);

 export default Flvjs;